import * as React from "react";
import { SelectChangeEvent } from "@mui/material";
import { fetchScreenings } from "../helpers/onCallFunctions.ts";
import {
 // CombinedFilmObject,
  FilmsInDateRange,
  SortOption,
} from "../types/dataTypes.ts";

type UseFilmListingsControllerArgs = {
  contextSlug: string;
  initialSelectedVenues: string[];
  validVenueSlugs?: string[];
  defaultSortOption?: SortOption;
  defaultOptimise?: boolean;
  enabled: boolean;
  selectedDateTabs?: string[];
};

export function useFilmListingsController({
  contextSlug,
  initialSelectedVenues,
  validVenueSlugs,
  defaultSortOption = "popular",
  defaultOptimise = false,
  enabled,
  selectedDateTabs,
}: UseFilmListingsControllerArgs) {
  const [filmsByDateRange, setFilmsByDateRange] = React.useState<
    FilmsInDateRange[]
  >([]);
  // const [totalNumberOfShowtimes, setTotalNumberOfShowtimes] =
  //   React.useState<number>();
  const [selectedVenues, setSelectedVenues] = React.useState<string[]>([]);
  const [sortOption, setSortOption] =
    React.useState<SortOption>(defaultSortOption);

  const [isInitialLoading, setIsInitialLoading] = React.useState(true);
  const [isRefreshing, setIsRefreshing] = React.useState(false);

  const [isVenueModalOpen, setIsVenueModalOpen] = React.useState(false);
  const [optimise, setOptimisation] = React.useState(defaultOptimise);

  // const getTotalScreenings = (filmData: CombinedFilmObject[]): number => {
  //   const numberOfScreenings = filmData.reduce((total, film) => {
  //     const filmTotal = film.screenings_data.reduce((sum, day) => {
  //       return sum + day.screenings.length;
  //     }, 0);

  //     return total + filmTotal;
  //   }, 0);

  //   const roundDownToNearest100 = (n: number) => Math.floor(n / 100) * 100;

  //   const roundedDownScreenings = roundDownToNearest100(numberOfScreenings);

  //   return roundedDownScreenings > 99
  //     ? roundedDownScreenings
  //     : numberOfScreenings;
  // };

  const fetchAndSet = React.useCallback(
    async (venues: string[], isInitial: boolean) => {
      if (!isInitial) {
        setIsRefreshing(true);
      }

      try {
        const { screenings_by_date, all_screenings_on_all_dates } =
          await fetchScreenings(venues, contextSlug, isInitial);

        const screeningsArray = [
          all_screenings_on_all_dates,
          ...screenings_by_date,
        ];

        // setTotalNumberOfShowtimes(
        //   getTotalScreenings(all_screenings_on_all_dates.film_data),
        // );

        setFilmsByDateRange(
          selectedDateTabs
            ? screeningsArray.filter((obj) =>
                selectedDateTabs?.includes(obj.tab_date_label),
              )
            : screeningsArray,
        );
        setSelectedVenues(venues);
      } finally {
        if (isInitial) setIsInitialLoading(false);
        else setIsRefreshing(false);
      }
    },
    [contextSlug, selectedDateTabs],
  );

  React.useEffect(() => {
    if (!enabled) return;

    fetchAndSet(initialSelectedVenues, true);
  }, [enabled, initialSelectedVenues, fetchAndSet]);

  const handleSortChange = React.useCallback((event: SelectChangeEvent) => {
    setOptimisation(true);
    setSortOption(event.target.value as SortOption);
  }, []);

  const onVenueToggle = React.useCallback((clickedVenue: string) => {
    setSelectedVenues((prev) => {
      const isSelected = prev.includes(clickedVenue);
      if (isSelected) {
        return prev.length > 1 ? prev.filter((v) => v !== clickedVenue) : prev;
      }
      return [...prev, clickedVenue];
    });
  }, []);

  const toggleSelectAllVenues = React.useCallback(
    (selectAll: boolean) => {
      if (!validVenueSlugs || validVenueSlugs.length === 0) return;

      if (selectAll) setSelectedVenues(validVenueSlugs);
      else setSelectedVenues([validVenueSlugs[0]]);
    },
    [validVenueSlugs],
  );

  const applyVenueSelection = React.useCallback(async () => {
    setOptimisation(true);
    await fetchAndSet(selectedVenues, false);
    setIsVenueModalOpen(false);
  }, [fetchAndSet, selectedVenues]);

  return {
    filmsByDateRange,
    selectedVenues,
    sortOption,

    isInitialLoading,
    isRefreshing,

    isVenueModalOpen,
    setIsVenueModalOpen,

    optimise,
    setOptimisation,

    handleSortChange,
    onVenueToggle,
    toggleSelectAllVenues,
    applyVenueSelection,

    setSelectedVenues,
  //  totalNumberOfShowtimes,
  };
}
